import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Image = styled.img.attrs({
  src: `${process.env.PUBLIC_URL}/gcb_logo.png`,
  title: 'Gold Coast Botany'
})`
  display: block;
  padding: 0 1rem;
  height: 3.5rem;
  margin: 1rem 0;
  width: auto;
`

export default ({className}) => (
  <Link to='/' className={className}>
    <Image />
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/Logo.js